/** Query parameter that marks a selected venue as the default venue. */
export const SET_AS_DEFAULT_VENUE_SEARCH_PARAM = 'd';

/** Cookie that persists the API partner settings ID of the last selected venue. */
export const LAST_VENUE_COOKIE = 'om_last_venue';

/** Internal request header used to force handling through the venue router. */
export const FORCE_VENUE_ROUTER_HEADER = 'x-force-venue-router';

/** Cookie and session-storage key that identifies an active venue-router session. */
export const USER_SESSION = 'om_session';
